import { api } from 'shared';
import { z } from 'zod';

export const CateringEventFormatsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
            category: z.object({
                documentId: z.string(),
                name: z.string(),
                slug: z.string(),
            }).optional().nullable(),
            slug: z.string(),
        }),
    ),
});
export const fetchCateringEventFormats = async () => (
    api.get<z.infer<typeof CateringEventFormatsResponseSchema>>(
        '/catering-event-formats',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                category: {
                    fields: '*',
                },
            },
        },
        CateringEventFormatsResponseSchema,
    )
);
